{
  "overridesEnabledBadgeLabel": "Overrides on",
  "releaseBadgeAlpha": "Alpha",
  "releaseBadgeBeta": "Beta",
  "releaseBadgeDev": "Dev",
  "releaseBadgePoc": "POC"
}
